// src/config.js
// get updates from https://console.firebase.google.com/u/0/project/onserv-host-prod/settings/

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_TRADER_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_TRADER_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_TRADER_GCLOUD_PROJECT_ID,
  storageBucket: process.env.REACT_APP_TRADER_GCLOUD_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_TRADER_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_TRADER_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_TRADER_FIREBASE_MEASUREMENT_ID,
};

export const GCLOUD_CONFIG = {
  appUrl: process.env.REACT_APP_TRADER_BASE_URL || 'https://trader.onserv.com',
  appApiUrl: process.env.REACT_APP_TRADER_BASE_API_URL || 'https://trader.onserv.com/api',
  adSenseClientId: process.env.REACT_APP_TRADER_GCLOUD_ADSENSE_ID || 'ca-pub-2077997023046219',
}

export const TRADER_DEFAULT_CONFIG = {
  defaultTickers: process.env.REACT_APP_TRADER_DEFAULT_TICKERS || 'RY.TO TD.TO BNS.TO ENB.TO BMO.TO CM.TO BCE.TO SU.TO TRP.TO CNR.TO',
  defaultProviders: process.env.REACT_APP_TRADER_DEFAULT_PROVIDERS || 'finance.yahoo.com'
}
